import React, { useEffect, useState } from "react";
import { Button, Typography, Box, TextField } from "@mui/material";
import { ContentCopy as CopyIcon } from "@mui/icons-material";
import "./Instructions.scss";
import driverAppIcon from "../../assets/images/driver-app-icon.png";
import { showToast } from "../../components/Toaster";

interface TransporterInfo {
  name: string;
  code: string;
}

const Instructions: React.FC = () => {
  const [transporterInfo, setTransporterInfo] = useState<TransporterInfo[]>([]);

  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail");

    if (userEmail === "operation@cnbtek.com") {
      setTransporterInfo([
        { name: "AQDAS MARITIME", code: "AQDA9920" },
        { name: "CNB TRANSPORT", code: "ST-TR-CNB-3371" },
      ]);
    } else if (userEmail === "nakshfed@cnbtek.com") {
      setTransporterInfo([{ name: "Naksha Transporter", code: "ST-TR--1F35" }]);
    } else if (userEmail === "it@acmpl.co") {
      setTransporterInfo([
        { name: "Naksha Transporter", code: "ST-TR-NAK-600C" },
      ]);
    } else if (userEmail === "globiconfed@cnbtek.com") {
      setTransporterInfo([
        { name: "GLOBICON TRANSPORT", code: "ST-TR-GLOBICON-AB12" },
      ]);
    } else {
      setTransporterInfo([{ name: "Demo Transporter", code: "999999" }]);
    }
  }, []);

  const appDetails = {
    name: "Smart Transport",
    version: "2.1.1",
    downloadLink:
      process.env.REACT_APP_ENV === "production"
        ? "https://drive.google.com/file/d/1QMxPMHHBrkfpBVb0S_Klti5mjpLdgNtK/view?usp=drive_link"
        : "https://drive.google.com/file/d/1v1P7TelRtNTNhKezVjDWIsQT1vA3tuha/view?usp=drive_link",
  };

  const handleCopyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    showToast("Copied to clipboard!", "success");
  };

  const registrationSteps = [
    {
      title: "Step 1",
      description: "Download and install the provided APK over android device",
    },
    {
      title: "Step 2",
      description: "Enter 10 digit mobile number",
    },
    {
      title: "Step 3",
      description: "Enter appropriate Transporter Code (#STID)",
    },
    {
      title: "Step 4",
      description: "Verify the transporter details displayed on the screen",
    },
    {
      title: "Step 5",
      description: "Enter Driver Name, Phone number and Truck Number",
    },
    {
      title: "Step 6",
      description: "Enter the OTP received on the mobile number to login",
    },
  ];

  return (
    <div className="instructions-page p-[20px]">
      <div className="instructions-container">
        {/* App Information Section */}
        <div className="card app-info">
          <div className="card-header">
            <h2>Driver App Information</h2>
          </div>
          <div className="card-body">
            <div className="app-info-container">
              <div className="app-icon-container">
                <img
                  src={driverAppIcon}
                  alt="Driver App Icon"
                  className="app-icon"
                />
              </div>
              <div className="app-details">
                <div className="info-item">
                  <div className="label">App Name</div>
                  <div className="value">{appDetails.name}</div>
                </div>
                <div className="info-item">
                  <div className="label">Version</div>
                  <div className="value">{appDetails.version}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Download Link Section */}
        <div className="card download-info">
          <div className="card-header">
            <h2>Download Link</h2>
          </div>
          <div className="card-body">
            <div className="download-link-container">
              <div className="label">App Download URL</div>
              <div className="link-input-group">
                <TextField
                  fullWidth
                  value={appDetails.downloadLink}
                  variant="outlined"
                  size="small"
                  slotProps={{
                    input: {
                      readOnly: true,
                      className: "code-input",
                      endAdornment: (
                        <a
                          href={appDetails.downloadLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="open-link"
                        >
                          Open
                        </a>
                      ),
                    },
                  }}
                />
                <Button
                  variant="outlined"
                  startIcon={<CopyIcon />}
                  onClick={() => handleCopyToClipboard(appDetails.downloadLink)}
                  className="copy-button"
                >
                  Copy
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Sharing Code Section */}
        <div className="card sharing-info">
          <div className="card-header">
            <h2>Transporter Codes (#STID)</h2>
          </div>
          <div className="card-body">
            {transporterInfo.map((transporter, index) => (
              <div key={index} className="transporter-section">
                <div className="transporter-details">
                  <div className="transporter-name">
                    <span className="label">Transporter Name</span>
                    <div className="value">{transporter.name}</div>
                  </div>
                  <div className="transporter-code">
                    <span className="label">Transporter Code</span>
                    <div className="link-input-group">
                      <TextField
                        fullWidth
                        value={transporter.code}
                        variant="outlined"
                        size="small"
                        slotProps={{
                          input: {
                            readOnly: true,
                            className: "code-input",
                          },
                        }}
                      />
                      <Button
                        variant="outlined"
                        startIcon={<CopyIcon />}
                        onClick={() => handleCopyToClipboard(transporter.code)}
                        className="copy-button"
                      >
                        Copy
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Registration Instructions Section */}
        <div className="card registration-info">
          <div className="card-header">
            <h2>Driver Registration Instructions</h2>
          </div>
          <div className="card-body">
            <div className="registration-steps">
              {registrationSteps.map((step, index) => (
                <div key={index} className="step-item">
                  <div className="step-number">{step.title}</div>
                  <div className="step-description">{step.description}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
